import { DataResponse } from '../../../models/common';
import { RemoteFlagsSet } from '../../../models/features';
import { createActionCreator, createActionCreatorWithoutPayload } from '../core-action-creators';
import { ErrorPayload, FailedPayload, ResultPayload } from '../core-actions';
import { RemoteFlagsActionType } from './remote-flags-actions';

export const initializeRemoteFlags = createActionCreatorWithoutPayload<DataResponse<RemoteFlagsSet>>(
    RemoteFlagsActionType.InitializeRemoteFlags,
    { async: true }
);

export const initializeRemoteFlagsError = createActionCreator<ErrorPayload>(
    RemoteFlagsActionType.InitializeRemoteFlagsError
);

export const initializeRemoteFlagsFailed = createActionCreator<FailedPayload>(
    RemoteFlagsActionType.InitializeRemoteFlagsFailed
);

export const initializeRemoteFlagsSuccess = createActionCreator<ResultPayload<RemoteFlagsSet>>(
    RemoteFlagsActionType.InitializeRemoteFlagsSuccess
);
